<template>
  <div class="pbr">
    <!-- <div slot="header">
      <el-button  @click="close">关闭</el-button>
    </div> -->
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">供应商</div>
            <div class="view-value">{{ com.comfullname }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="split-line"></div>
    <vggrid :list="list" flexname="" :cols="cols" :showfooter="false" :needBlackRow="false" :showPage="false"
      :resizable="true">

      <template slot="btn">
        <el-button v-show="+project.prsflg === 4 || +project.prsflg === 5" style="float: right;" type="primary"
          @click="exportToExcel" size="small" icon="el-icon-download">导出报价记录</el-button>
      </template>
    </vggrid>
  </div>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from "../common/menuBtn"
import vggrid from '../common/vggrid'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
  name: 'pbrListForm',
  mixins: [common],
  props: {
    projectid: {},
    project: {
      default: {}
    },
    comid: {},
    comfullname: {}
  },
  data() {
    return {
      com: {},
      list: [],
      btnLoading: false,
      cols: []
    }
  },
  async mounted() {
    await this.init()
    await this.getModel()
    await this.getPageList()
  },
  async activated() {
    await this.init()
    // await this.getModel()
  },
  watch: {
    comid() {
      this.getModel()
      this.getPageList()
    }
  },
  components: { MenuBtn, vggrid },
  methods: {
    exportToExcel() {
      const data = this.list.map(item => {
        let obj = {}
        obj['报价轮次'] = item.pbtseq
        obj['最终报价'] = item.pbramt
        obj['报价人'] = item.username
        obj['报价时间'] = dayjs(item.pbrtime).format('YYYY-MM-DD HH:mm:ss')
        item.comfullname
        return obj
      })
      const cols = ['报价轮次', '最终报价', '报价人', '报价时间']
      const worksheet = XLSX.utils.json_to_sheet(
        data,
        {
          header: cols
        }
      );

      const max_width = data.reduce((w, r) => Math.max(w, r['报价时间'].length), 10);
      worksheet["!cols"] = [{ wch: 10 }, { wch: max_width * 2.2 }, { wch: 12 }, { wch: 26 }];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      // 生成blob对象
      const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })], { type: 'application/octet-stream' });
      var wbout = XLSX.write(workbook, { bookType: "xlsx", bookSST: true, type: "array" });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        this.list[0].comfullname + "报价记录表.xlsx"
      )
    },
    init() {
      this.cols = [
        { field: 'pbtseq', fieldtype: 'C', title: '报价轮次', calculExpr: '', addNewRowFlg: false, width: 100 },
        // { field: 'pbramt', fieldtype: 'C', title: '报价金额',calculExpr:'',addNewRowFlg: false},
        { field: 'username', fieldtype: 'C', title: '报价人', calculExpr: '', addNewRowFlg: false },
        {
            field: 'pbtseq', title: '报价时间', calculExpr: '', addNewRowFlg: false,
            slots: {
              default: 'default',
              default: ({ row }) => {
                return [
                  <div>{dayjs(row.pbrtime).format('YYYY-MM-DD HH:mm:ss.SSS ')}</div>
                ]
              }
            }
          }
      ]
      if (+this.project.projectquotationmode === 1) {
        this.cols.splice(1, 0, { field: 'pbramt', title: '最终报价', calculExpr: '', addNewRowFlg: false })
      } else if (+this.project.projectquotationmode === 2) {
        this.cols.splice(1, 0, { field: 'pbrpricerate', title: '上浮率%', calculExpr: '', addNewRowFlg: false })
      } else if (+this.project.projectquotationmode === 3) {
        this.cols.splice(1, 0, { field: 'pbrpricerate', title: '下浮率%', calculExpr: '', addNewRowFlg: false })
      } else if (+this.project.projectquotationmode === 4) {
        this.cols.splice(1, 0, { field: 'pbrpricerate', title: '折扣率%', calculExpr: '', addNewRowFlg: false })
      }
      if (+this.project.prsbjtimes > 1) {
        this.cols.splice(2, 0,
          {
            field: 'pbtseq', title: '报价文件', calculExpr: '', addNewRowFlg: false,
            slots: {
              default: 'default',
              default: ({ row }) => {
                return [
                  <div><a style="color: #2f74ff;cursor: pointer;" onClick={this.download.bind(this, row)}>{row.pbrpricefilename}</a></div>
                ]
              }
            }
          }
        )
      }
    },
    async getModel() {
      let comid = (this.$route.params.comid || this.comid) || this.$store.getters.loginUser.comid
      let data = await request({
        method: 'get',
        url: '/ywgl/com/getComById',
        params: { comid: comid }
      })
      if (data.length) {
        this.com = data[0]
      }
    },
    download(row) {
      console.log(row.appendurl)
      this.downFile(row.appendurl)
    },
    btnClick(code) {
      this.$emit(code)

    },
    async close() {
      this.$store.commit('close_tab', { routeName: this.$route.name, vm: this, newRouteName: 'projectPbrIndex' })
    },
    async getPageList() {
      this.loading = true
      let comid = (this.$route.params.comid || this.comid) || this.$store.getters.loginUser.comid
      let projectid = this.$route.params.projectid || this.projectid
      let res = await request({
        method: 'get',
        url: '/xmgl/project/getPbrList',
        params: { projectid: projectid, comid: comid, orderbyFlg: 'asc' }
      })
      this.list = res
      this.loading = false
      this.list.map(v => {
        v.pbramt = utils.comdify(v.pbramt)
        v.pbtseqdesc = '第' + v.pbtseq + '轮'
      })
    }
  },
  filters: {
  }
}
</script>
<style lang="scss">
.pbr {
  .view-container {
    padding-top: 0
  }

  .view-container .view-box .view-row .view-field .view-label {
    width: 60px;
  }

  .view-container .view-box .view-row {
    padding-bottom: 0
  }
}
</style>
